export { default } from "./icon-title";
